<div class="tw-flex tw-h-full tw-flex-col">
  @if (activeIndex < items.length - 1) {
    <icon
      (click)="nextChoice()"
      class="tw-cursor-pointer tw-mt-7 tw-absolute tw-right-0 tw-h-[90%] tw-p-5 tw-flex tw-justify-center tw-text-dt-text-headings sm:tw-hidden"
      [name]="'right-arrow'"
      [size]="5"
    ></icon>
  }
  @if (this.activeIndex > 0) {
    <icon
      (click)="previousChoice()"
      class="tw-cursor-pointer tw-absolute tw-left-0 tw-h-full tw-p-5 tw-flex tw-justify-center tw-text-dt-text-headings tw-rotate-180 sm:tw-hidden"
      [name]="'right-arrow'"
      [size]="5"
    ></icon>
  }
  <span
    class="tw-mb-6 tw-flex tw-text-base tw-font-medium tw-leading-[125%] tw-text-dt-text-headings"
  >
    {{ "topInterestRateAccounts" | i18n }}
  </span>

  <div
    class="tw-w-full tw-overflow-hidden"
    (touchstart)="onTouchStart($event)"
    (touchmove)="onTouchMove($event)"
    (touchend)="onTouchEnd()"
  >
    <div
      class="tw-flex tw-h-full tw-max-h-[575px] tw-pb-2 tw-transition-transform tw-duration-500"
      [ngStyle]="{ transform: 'translateX(-' + activeIndex * 100 + '%)' }"
    >
      <ng-content></ng-content>
    </div>
    <div
      class="tw-absolute tw-bottom-7 tw-left-1/2 tw-flex tw--translate-x-1/2 tw-transform tw-items-center tw-gap-2"
    >
      <span
        *ngFor="let item of items; let i = index; trackBy: trackByIndex"
        class="tw-cursor-pointer tw-rounded-full"
        [ngClass]="{
          'tw-h-4 tw-w-4 tw-bg-dt-custom-teal-9': isActive(i),
          'tw-h-2.5 tw-w-2.5 tw-bg-dt-surface-sunken': !isActive(i),
        }"
        (click)="setActiveIndex(i)"
      ></span>
    </div>
  </div>
</div>
